import { DataBlockDictionaryItemDto } from '@lmt/shared-types';
import {
  HookFormDropDownInput,
  HookFormProps,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/dropdown/DropDownInput';
import { useActiveDictionaryValuesById } from '@lmt/unicorn-shared/src/app/api/custom-hooks';
import { NS_DataBlockFields } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type DictionaryHookFormDropDownInputProps = {
  dictionaryId: number | null | undefined;
};

export function DictionaryHookFormDropDownInput<
  Required extends boolean | undefined = undefined,
  UseIdAsValue extends boolean | undefined = undefined,
  TFieldValues extends FieldValues = FieldValues,
>(
  props: Omit<
    HookFormProps<
      DataBlockDictionaryItemDto,
      Required,
      UseIdAsValue,
      TFieldValues
    >,
    'options' | 'getOptionLabel'
  > &
    DictionaryHookFormDropDownInputProps,
) {
  const { dictionaryId, ...rest } = props;
  const { data: options } = useActiveDictionaryValuesById(dictionaryId);
  const i18nDataBlockFields = useTranslation(
    [NS_DataBlockFields, 'translation'],
    { nsMode: 'fallback' },
  );
  return (
    <HookFormDropDownInput
      options={options}
      idFunction="id"
      getOptionLabel={(x) =>
        i18nDataBlockFields.t(x.value as any, {
          nsSeparator: false,
        })
      }
      {...rest}
    />
  );
}
